import React from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import AuthUserContext from './context';
import { withFirebase } from '../Firebase';

const withAuthorization = (condition) => (Component) => {
    class WithAuthorization extends React.Component {
        render() {
            return (
                <AuthUserContext.Consumer>
                    {(authUserAndRole) =>
                        condition(authUserAndRole[0]) ? (
                            <Component
                                {...this.props}
                                user={authUserAndRole[0]}
                                role={authUserAndRole[1]}
                                GiftCards={authUserAndRole[2]}
                            />
                        ) : null
                    }
                </AuthUserContext.Consumer>
            );
        }
    }

    return compose(withRouter, withFirebase)(WithAuthorization);
};

export default withAuthorization;
